"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_PREVIEW_PRODUCT = void 0;
const SEARCH_PREVIEW_PRODUCT = exports.SEARCH_PREVIEW_PRODUCT = 'search-preview-product';
